import config from "@/config"
import http from "@/utils/request"

export default {
  post: {
    url: `${config.API_URL}/forum-post`,
    name: "帖子列表",
    get: async function (params) {
      return await http.get(`${this.url}/list`, params)
    },
    submit: async function (data) {
      return await http.post(`${this.url}/submit`, data)
    },
    del: async function (data) {
      return await http.post(`${this.url}/delete`, data)
    }
  }
}
